<template>
  <div class="challenges-report-page">
    <div class="row">
      <div class="col-md-2">
        <flip-card id="db-readers-in-schools">
          <dash-box slot="front" title="Schools Registered" :value="totalOrgs.total" :active_value="totalOrgs.active" />
          <div slot="back" class="dashbox__help"><strong>{{totalOrgs.total.toLocaleString('en')}}</strong> schools have registered, <i class="fa fa-bolt"></i> <strong>{{ totalOrgs.active.toLocaleString('en') }}</strong> have at least 1 child who has read something.</div>
        </flip-card>
      </div>
      <div class="col-md-2">
        <flip-card id="db-readers-in-schools">
          <dash-box slot="front" title="Parents Registered" :value="totalUsers.total" :active_value="totalUsers.active" />
          <div slot="back" class="dashbox__help"><strong>{{totalUsers.total.toLocaleString('en')}}</strong> parents have registered, <i class="fa fa-bolt"></i> <strong>{{ totalUsers.active.toLocaleString('en') }}</strong> have at least 1 child who has read something.</div>
        </flip-card>
      </div>
      <div class="col-md-2">
        <flip-card id="db-readers-registered">
          <dash-box slot="front" title="Readers Registered" :value="totalReaders.total" :active_value="totalReaders.active" />
          <div slot="back" class="dashbox__help"><strong>{{totalReaders.total.toLocaleString('en')}}</strong> children are in the challenge, <i class="fa fa-bolt"></i> <strong>{{ totalReaders.active.toLocaleString('en') }}</strong> have read something.</div>
        </flip-card>
      </div>
      <div class="col-md-2">
        <flip-card id="db-readers-in-schools">
          <dash-box slot="front" title="Readers Associated to a School" :value="readersInOrgs.total" :active_value="readersInOrgs.active" />
          <div slot="back" class="dashbox__help"><strong>{{readersInOrgs.total.toLocaleString('en')}}</strong> children are associated with a school, <i class="fa fa-bolt"></i> <strong>{{ readersInOrgs.active.toLocaleString('en') }}</strong> have read something.</div>
        </flip-card>
      </div>
      <div class="col-md-2">
        <flip-card id="db-readers-not-in-school">
          <dash-box slot="front" title="Readers not in School" :value="readersNotInOrgs.total" :active_value="readersNotInOrgs.active" />
          <div slot="back" class="dashbox__help"><strong>{{readersNotInOrgs.total.toLocaleString('en')}}</strong> children are <strong><u>not</u></strong> associated with a school, <i class="fa fa-bolt"></i> <strong>{{ readersNotInOrgs.active.toLocaleString('en') }}</strong> have read something.</div>
        </flip-card>
      </div>
      <div class="col-md-2">
        <div class="btn-group" style="width:100%;">
          <button type="button" class="btn btn-primary dropdown-toggle" style="width:100%;" data-toggle="dropdown" :disabled="isExporting">
            {{  isExporting ? 'Exporting' : 'Export Data' }}
            <i v-if="isExporting" class="fa fa-spin fa-spinner ml-2"></i>
            <span v-else class="caret ml-2"></span>
          </button>
          <ul class="dropdown-menu">
            <li><a href="#" @click.prevent="getSchoolsCSV">Schools CSV</a></li>
            <li><a href="#" @click.prevent="getReadersCSV">Readers CSV</a></li>
          </ul>
        </div>
        <div class="user-filters mt-4" style="float:right">
            <div class="user-filter user-filter__break">
              <div class="label-container">
                <label>Challenge:</label>
              </div>
              <select name="challenges" id="challenges" v-model="challenge" @change="refreshData">
                <option v-for="ch in challenges" :value="ch.slug" :key="ch.id">{{ ch.slug | uppercase }}</option>
              </select>
            </div>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;">Partner Referrals</h2>

        <table class="table table-striped table-hover table-condensed" style="background:white;box-shadow: 2px 2px 3px 0px #c7d5e6;">
          <thead>
            <tr><th>Partner</th><th>Schools</th><th>Parents</th></tr>
          </thead>
          <tbody>
            <tr v-for="(p, i) in partners" :key="i">
              <td>{{ p.name }}</td>
              <td>{{ p.organisations_referred_count }}</td>
              <td>{{ p.users_referred_count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-6">
        <div>
        <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;">Regional Breakdown</h2>
          <table class="table table-striped table-hover table-condensed" style="background:white; box-shadow: 2px 2px 3px 0px #c7d5e6;">
            <thead>
              <tr><th>Region</th><th>Schools</th><th>Parents</th><th>Readers</th></tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in regions" :key="i">
                <td>{{ r || 'Unknown Region' }}</td>
                <td>{{ orgRegionStats(r).total }}</td>
                <td>{{ totalUsers.regional[r].total }}</td>
                <td>{{ totalReaders.regional[r].total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;">Certificates & Stars</h2>
          <table class="table table-striped table-hover table-condensed" style="background:white; box-shadow: 2px 2px 3px 0px #c7d5e6;">
            <thead>
              <tr><th></th><th>Awarded</th></tr>
            </thead>
            <tbody>
              <tr v-for="(c, i) in certificates" :key="i">
                <td v-tooltip="{content:c.description, placement: 'auto-start'}">{{ c.name }}</td>
                <td>{{ c.count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="report-header">
          <h2 style="font-weight: 200;color: #224450;text-shadow: 1px 1px 0 #ffffffb3;">Schools</h2>
        </div>
      </div>
      <div class="col-md-12">
        <vue-good-table
          styleClass="vgt-table striped"
          theme="auris-admin"
          :columns="columns"
          :rows="data"
          :totalRows="data.length"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 25,
            position: 'bottom',
            perPageDropdown: [10, 25, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table',
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'name', type: 'asc'}
          }"
          @on-sort-change="handleSortChange"
          >
           <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'name'">
              <a :href="`/challenges/${challenge}/organisations/${props.row.id}`">{{props.row.name}}</a>
            </span>
            <span v-else-if="props.column.field === 'rank'" v-html="numberRank(props.row.rank)">
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>
<script>
import { VueGoodTable } from 'vue-good-table';
import DashBox from '@/components/DashBox';
import moment from 'moment';
import { mapState } from 'vuex';
import FlipCard from '@/components/FlipCard';
import VTooltip from 'v-tooltip';

const transformHeader = (s) => s.replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()).replace(/[-_]+(.)/g, (_, c) => ` ${c.toUpperCase()}`);

const secondsToString = (seconds = 0) => {
  if (seconds < 60) {
    return `${seconds} ${seconds === 1 ? 'sec' : 'secs'}`;
  }
  const hours = Math.floor(seconds / 3600);
  const totalSeconds = seconds % 3600;
  const minutes = Math.floor(totalSeconds / 60);
  let string = '';
  if (hours >= 1) {
    string += `${hours} ${hours === 1 ? 'hr ' : 'hrs '}`;
  }
  if (minutes >= 1) {
    string += `${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
  }

  return string.trim();
};

class ReportItem {
  constructor(item) {
    this.rank = '';
    this.id = item.id || null;
    this.name = item.name || '';
    this.code = item.code || '';
    this.contact_name = item.contact_name || '';
    this.contact_email = item.contact_email || '';
    this.school_type = item.school_type ? item.school_type.toUpperCase() : '';
    this.governed_by = item.school_governed_by_name || '';
    this.region = item.region || '';
    this.registered_on = item.created_at || '';
    this.total_readers = item.total_readers || 0;
    this.active_readers = item.total_active_readers || 0;
    this.recently_active_readers = item.total_recent_active_readers || 0;
    this.stars = 0;
    this.books_read = 0;
    this.reading_time_seconds = 0;
    if (item.leaderboard) {
      this.stars = item.leaderboard.total_stars || 0;
      this.books_read = item.leaderboard.total_books || 0;
      this.reading_time_seconds = item.leaderboard.total_reading_time || 0;
    }
    switch (this.school_type) {
      case 'MAT':
        this.school_type = 'Multi-Academy Trust';
        break;
      case 'LA':
        this.school_type = 'Local Authority';
        break;
      default:
        this.school_type = '';
        break;
    }
  }
}

export default {
  components: {
    VueGoodTable,
    DashBox,
    FlipCard,
    VTooltip, // eslint-disable-line
  },
  data() {
    return {
      columns: [
        {
          label: 'Rank',
          field: 'rank',
          type: 'number',
          sortable: false,
          hidden: true,
        },
        {
          label: 'Name',
          show_ranking: false,
          field: 'name',
          sortable: true,
        },
        {
          label: 'School Type',
          field: 'school_type',
          sortable: false,

        },
        {
          label: 'Governed by',
          field: 'governed_by',
        },
        {
          label: 'Registered On',
          field: 'registered_on',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'do MMMM yy @ hh:mm a',
        },
        {
          label: 'Total Readers',
          field: 'total_readers',
          type: 'number',
        },
        {
          label: 'Active Readers',
          field: 'active_readers',
          type: 'number',
        },
        {
          label: 'Stars',
          field: 'stars',
          type: 'number',
        },
        {
          label: 'Books',
          field: 'books_read',
          type: 'number',
        },
        {
          label: 'Reading Time',
          field: 'reading_time_seconds',
          formatFn: (seconds) => secondsToString(seconds),
          type: 'number',
        },
      ],
      data: [],
      readersInOrgs: { total: 0, active: 0 },
      totalReaders: { total: 0, active: 0 },
      totalUsers: { total: 0, active: 0 },
      gettingCSV: false,
      isLoading: false,
      isExporting: false,
      challenge: 'uknrac25',
      partners: [],
      regions: [],
      certificates: [],
    };
  },
  computed: {
    ...mapState('challenges', ['challenges']),
    totalOrgs() {
      return {
        total: this.data.length,
        active: this.data.filter((s) => s.active_readers > 0).length,
      };
    },
    readersNotInOrgs() {
      return {
        total: this.totalReaders.total - this.readersInOrgs.total,
        active: this.totalReaders.active - this.readersInOrgs.active,
      };
    },
  },
  methods: {
    refreshData() {
      this.isLoading = true;
      this.$store.dispatch('reports/getChallengesReport', this.challenge).then((response) => {
        const { data } = response;
        this.data = data.challenge_organisations.map((item) => new ReportItem(item));
        this.readersInOrgs = data.total_challenge_organisation_readers;
        this.totalReaders = data.total_challenge_readers;
        this.totalUsers = data.total_challenge_users;
        this.partners = data.challenge_partners;
        this.certificates = data.challenge_certificates;
        this.regions = Array.from(new Set([
          ...Object.keys(this.totalUsers.regional),
          ...Object.keys(this.totalReaders.regional),
        ])).sort();
      }).finally(() => {
        this.isLoading = false;
      });
    },
    orgRegionStats(r) {
      const orgsInRegion = this.data.filter((s) => s.region === r);
      return {
        total: orgsInRegion.length,
        active: orgsInRegion.filter((s) => s.active_readers > 0).length,
      };
    },
    getSchoolsCSV() {
      const items = this.data;
      const header = Object.keys(items[0]); console.log(header);
      header.shift();
      const formattedHeader = header.map(transformHeader);
      const csv = [
        formattedHeader.join(','), // header row first
        ...items.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName])).join(',')),
      ].join('\r\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `challenges_report${moment().format('DD/MM/YYYY')}.csv`);
        link.style = 'visibility:hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getReadersCSV() {
      this.isExporting = true;
      this.$store.dispatch('challenges/exportReadersCsv', this.challenge).then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.challenge} readers list.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      }).finally(() => {
        this.isExporting = false;
      });
    },
    numberSort(direction = 'asc', key = null) {
      return (a, b) => {
        const valA = parseFloat(key ? a[key] : a);
        const valB = parseFloat(key ? b[key] : b);
        return direction === 'asc' ? valA - valB : valB - valA;
      };
    },
    numberRank(n) {
      const s = ['th', 'st', 'nd', 'rd'];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
    handleSortChange(params) {
      const { field, type } = params[0];
      const rankingEnabledFields = ['reading_time_seconds', 'books_read', 'stars'];
      if (rankingEnabledFields.includes(field) && type !== 'none') {
        this.calculateRanking(field, type);
        this.$set(this.columns[0], 'hidden', false);
      } else {
        this.$set(this.columns[0], 'hidden', true);
      }
    },
    calculateRanking(field, type) {
      const sortedData = [...this.data].sort(this.numberSort(type, field));
      sortedData.forEach((item, index) => {
        item.rank = index + 1;
      });
    },
    async getChallenges() {
      if (this.challenges.length === 0) {
        await this.$store.dispatch('challenges/getChallenges');
      }
    },
  },
  async mounted() {
    await this.getChallenges();
    // Set the selected challenge to the latest one.
    this.challenge = this.challenges.reduce((max, current) => (current.id > max.id ? current : max)).slug;
    await this.refreshData();
  },
};
</script>
<style lang="scss" scoped>
.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
</style>
